export const DESCRIPTIVE_FLEXFIELDS_SLICE = 'DESCRIPTIVE_FLEXFIELDS_SLICE';

export const DRILLDOWN_DFF_TABLE_NAME = 'wdl.table_report_drill_down';

export const GLOBAL_CONTEXT = 'GLOBAL';
